module.exports = __webpack_public_path__ + "b807c9115a741574fd38e6a52ba90ad1.png";